import { CREATE_MODALS, SINGLE_EMPLOYEE_REQUIRED_FIELDS } from "global/constants";
import { fieldNames } from "global/fieldNameMapping";
import AmplitudeHelper from "utils/analytics";
import { getErrorMessage, showErrorToast } from "utils/utilities";
import { validationCheck } from "utils/validation";
import en from "i18n/en";
import id from "i18n/id";

export function checkOnSuccess(createSuccess, showCreateUpdateSuccessToast, createEmployeeResponse, navigate, toast) {
  if (createSuccess) {
    showCreateUpdateSuccessToast({
      createEmployeeResponse,
      navigate,
      toast,
      isCreate: true,
    });
  }
}

export function checkErrorsOnCreate(isCreateError, createError, t, setErrors, toast, navigate, resetLoginData) {
  if (isCreateError && createError?.length > 0) {
    const newErrors = {};

    createError.forEach((errorCode) => {
      const field = fieldNames[errorCode]; // map field name to particular error code and select out that one field which corresponds to the error code
      if (field) {
        newErrors[`${field}`] = getErrorMessage(t, errorCode, createError?.errorParams);
      }
    });

    if (Object.keys(newErrors).length != 0) {
      setErrors(newErrors);
    } else {
      showErrorToast({ error: createError, toast, navigate, resetLoginData });
    }
  }
}

export function validatorOnSubmit(values, setErrors, setFormData, setModal, modal, scrollToError) {
  const newErrors = {};
  // "group" is optional (removed from Mandatory fields discussed with Desy and team)
  const required = SINGLE_EMPLOYEE_REQUIRED_FIELDS;
  const inputs = ["phone"];

  required.forEach((field) => {
    const fieldValue = values[field];
    if (!fieldValue || fieldValue.toString().trim() == "") {
      newErrors[`${field}`] = "basicValidation.missingFields";
    }
  });

  inputs.forEach((field) => {
    const validation = validationCheck[`${field}`](values[`${field}`]);
    if (validation != "" && newErrors[`${field}`] != "basicValidation.missingFields") {
      newErrors[`${field}`] = validation;
    }
  });

  if (Object.keys(newErrors).length != 0) {
    setErrors(newErrors);
    scrollToError(newErrors);
  } else {
    setErrors({});
    setFormData(values);
    AmplitudeHelper.logEvent("save_button_clicked", {
      source: "employee_single_creation_page",
    });

    setModal({
      ...modal,
      type: CREATE_MODALS.singleCreate,
      data: { ...values },
    });
  }
}

// The "no group" option is stored as its translated label, which may be in the language the page was
// loaded in rather than the current one (e.g. loaded in English, submitted after switching to Bahasa).
const NO_GROUP_LABELS = [en.employeeCreation.single.noGroup, id.employeeCreation.single.noGroup];

export function isNoGroup(group, t) {
  return group === t("employeeCreation.single.noGroup") || NO_GROUP_LABELS.includes(group);
}

export function getGroupData(data, t) {
  return isNoGroup(data?.group, t) ? "" : data?.group;
}

export function getGroupName(data, t) {
  return data?.group ? getGroupData(data, t) : "";
}

export function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

export const formatUnderScoreLowerCase = (keyWord) => {
  if (!keyWord || keyWord.length === 0) {
    return keyWord;
  }
  return keyWord?.toLowerCase()?.replace(/ /g, "_") ?? "";
};

export function showComponents(employerConfigData, route) {
  if (employerConfigData?.isInitialOnboarding) return route?.isInitialOnboarding;
  return route?.isMainFlow;
}
